import React from 'react'
import { FieldWithCredit, Field, Links } from './'

import { BUSINESS_GRID } from '../../../../lib/constants'

const BusinessListItem = ({ data, last, hovered, setHovered }) => {
	return (
		
		<div
			className='business'
			onMouseEnter={() => setHovered(true)}
			onMouseLeave={() => setHovered(false)}
		>
			<div className='business-name'> 
				<FieldWithCredit className="field-business-name" bold sanSerif credit={data.photoCredit} active={hovered}>
					{data.business}
				</FieldWithCredit>
			</div>

			<div className="city">
				<Field>{data.city}</Field>
			</div>
			<div className="name">
				<Field>{data.name}</Field>
			</div>
			<div className='industry'>
				<Field>{data.industry}</Field>
			</div>

			<Links {...data} />
			<style jsx>{`
				.business {
					display: grid;
					grid-template-columns: ${BUSINESS_GRID};
					width: 100%;
					padding: 1.25rem 0;

					border-bottom: ${last ? 0 : '1px solid black'};
					padding-bottom: 3rem;
				}
				

				@media (max-width: 769px), (pointer: coarse) {
					.business {
						display: block;
						padding: 1.25rem 0;
					}



					.business-name {
						margin-bottom: 15px;
					}

					.business-name :global(.field-business-name) {
						font-size: 26px;
					}
					.city, .name, .industry {
						margin-bottom: 12px;
					}
					.industry {
						margin-bottom: 30px;
					}
				}
			`}</style>
		</div>

		
	)
}

export default BusinessListItem
